module.exports = require("npm:lodash@4.17.4/lodash.js");